(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lbt005-final"] && !Shopify.designMode) return;
  try {
    
  function initializeLintLumeTrustStack(root) {
    if (root.dataset.lbt005Ready === 'true') return;
    root.dataset.lbt005Ready = 'true';
    const setOutput = root.querySelector('[data-lbt005-trust-set]');
    const priceOutput = root.querySelector('[data-lbt005-trust-price]');
    const variantInputs = Array.from(root.querySelectorAll('input[type="radio"][name="id"]'));
    const updateVariant = (input) => {
      variantInputs.forEach((candidate) => { candidate.checked = candidate.value === input.value; });
      if (setOutput) setOutput.textContent = input.dataset.trustTitle;
      if (priceOutput) priceOutput.textContent = input.dataset.trustPrice;
    };
    variantInputs.forEach((input) => input.addEventListener('change', () => updateVariant(input)));
    root.querySelectorAll('[data-lbt005-carousel]').forEach((track) => {
      const cards = Array.from(track.children);
      const counter = track.parentElement.querySelector('[data-lbt005-counter]');
      let pending = false;
      const updateCounter = () => {
        pending = false;
        let closest = 0;
        let distance = Number.POSITIVE_INFINITY;
        cards.forEach((card, index) => {
          const current = Math.abs(card.offsetLeft - track.scrollLeft - track.offsetLeft);
          if (current < distance) { distance = current; closest = index; }
        });
        if (counter) counter.textContent = `${closest + 1} / ${cards.length}`;
      };
      track.addEventListener('scroll', () => {
        if (!pending) { pending = true; window.requestAnimationFrame(updateCounter); }
      }, { passive: true });
      updateCounter();
    });
  }
  function initializeAllLintLumeTrustStacks() {
    document.querySelectorAll('[data-lbt005-root]').forEach(initializeLintLumeTrustStack);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllLintLumeTrustStacks, { once: true });
  } else {
    initializeAllLintLumeTrustStacks();
  }
  document.addEventListener('shopify:section:load', initializeAllLintLumeTrustStacks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
